import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import FavouritesManager from "../services/favourite-manager";

export default class MobileMenuBehavior extends AbstractDataAttributeBehaviour {

    attrSelectors = {
        type: 'data-shortlist-type',
        subtype: 'data-shortlist-subtype',
    };

    favouritesManager = new FavouritesManager();

    getContainerSelector()
    {
        return '[' + this.attrSelectors.type + ']';
    }

    initContainer(container)
    {
        let type = container.getAttribute(this.attrSelectors.type);
        let subType = container.getAttribute(this.attrSelectors.subtype);

        let x = this.favouritesManager.getFavouritesAsString(type, subType);
        container.value = x;
    }
}